<template>
  <div>
    <div class="tab-pane-body-basic">
      <el-form ref="basicSetupForm" :model="courseInfo" :rules="basicInfoRules" label-position="right" label-width="112px">
        <el-form-item label="课程名称" prop="title">
          <el-input v-model="courseInfo.title"></el-input>
        </el-form-item>
        <el-form-item label="所属分类" prop="category_id">
          <el-cascader
            placeholder="选择分类"
            :props="cascaderProps"
            :options="categoryList"
            v-model="selectedList"
            @change="cascaderChange"
            show-all-levels
            clearable
            filterable>
          </el-cascader>
        </el-form-item>
        <el-form-item label="课程标签" prop="label_ids">
          <el-select v-model="courseInfo.label_ids" filterable clearable multiple placeholder="选择课程标签">
            <el-option
              v-for="item in labelList"
              :key="item.id"
              :label="item.display_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程简介" prop="intro">
          <el-input type="textarea" v-model="courseInfo.intro"></el-input>
        </el-form-item>
        <el-form-item label="课程图片" prop="cover">
          <ApeUploader :limit="1" @handleUploadSuccess="handleUploadSuccess" @handleUploadRemove="handleUploadRemove" :upload-file-list="uploadFileList"></ApeUploader>
        </el-form-item>
        <el-form-item label="课程讲义" prop="attach_id">
          <ApeUploader :limit="1" :isImage="false" :allowSize="1024*1024*500" :allowTypeList="handoutTypeList" @handleUploadSuccess="handleUploadHandoutSuccess" @handleUploadRemove="handleUploadHandoutRemove" :upload-file-list="uploadHandoutFileList"></ApeUploader>
        </el-form-item>
        <el-form-item label="SEO标题" prop="seo_title">
          <el-input v-model="courseInfo.seo_title"></el-input>
        </el-form-item>
        <el-form-item label="SEO关键词" prop="seo_keywords">
          <el-input v-model="courseInfo.seo_keywords"></el-input>
        </el-form-item>
        <el-form-item label="SEO描述" prop="seo_description">
          <el-input type="textarea" v-model="courseInfo.seo_description"></el-input>
        </el-form-item>
      </el-form>  
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import ApeUploader from '@/components/ApeUploader'

export default {
  components: {
    ApeUploader
  },
  props: {
    // 课程信息
    courseInfo: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  // 定义属性
  data() {
    return {
      // 课程基本信息规则
      basicInfoRules: {
        title: [
          {required: true, message: '输入课程名称', trigger: 'blur' },
        ],
        cover: [
          {required: true, message: '请上传图片', trigger: 'blur', validator:this.apeUploaderVerify},
        ],
      },
      // 分类联动
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      // 分类列表
      categoryList:[],
      // 标签列表
      labelList:[],
      // 已选中的分类列表，用于cascader组件选中效果
      selectedList:[],
      // 已上传文件列表
      uploadFileList:[],
      // 课程讲义支持上传类型
      handoutTypeList:['application/pdf','application/zip','application/rar'],
      // 课程讲义上传列表
      uploadHandoutFileList:[],
    }
  },
  // 方法集合
  methods: {
    async initCourseCategory() {
      // 获取课程分类列表
      let data = await this.$api.getCourseCategoryList()
      this.categoryList = data.category
      this.labelList = data.label
    },
    // 初始化基础信息
    initBasicInfo() {
      if (typeof(this.courseInfo.title) == 'undefined') {
        return false
      }
      this.selectedList = this.courseInfo.category_ids
      this.uploadFileList = [{id:this.courseInfo.image_info.id,name:this.courseInfo.image_info.title,url:this.courseInfo.image_info.full_path}]
      if (this.courseInfo.attach_id) {
        this.uploadHandoutFileList = [{id:this.courseInfo.attach_info.id,name:this.courseInfo.attach_info.title,url:this.courseInfo.attach_info.full_path}]
      }
    },
    // 级联菜单组件change事件
    cascaderChange(v) {
      if (typeof(v)!='undefined' && v.length) {
        this.courseInfo.category_id = v[(v.length-1)]
        this.courseInfo.category_ids = v
      }
    },
    // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      this.courseInfo.cover = file.id
      this.uploadFileList = fileList
    },
    // 图片删除回调
    handleUploadRemove(file, fileList) {
      this.courseInfo.cover = 0
      this.uploadFileList = fileList
    },
    // 课程讲义上传成功回调
    handleUploadHandoutSuccess(file, fileList) {
      this.courseInfo.attach_id = file.id
      this.uploadHandoutFileList = fileList
    },
    // 课程讲义删除回调
    handleUploadHandoutRemove(file, fileList) {
      this.courseInfo.attach_id = 0
      this.uploadHandoutFileList = fileList
    },
    // 基本信息表单验证
    formValidate() {
      this.$refs['basicSetupForm'].validate((valid) => {
        if (valid) {
          this.$emit('formSubmit',this.courseInfo)
        } else {
          this.$message.error('数据验证失败，请检查必填项数据1！')
        }
      })
    },
    // 图片上传自定义验证
    apeUploaderVerify(rule, value, callback) {
      if (rule.required && !this.courseInfo.cover) {
        callback(new Error(rule.message))
      }
      callback()
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.initCourseCategory()
    this.initBasicInfo()
  }
}
</script>

<style lang='stylus'>
  .tab-pane-body-basic
    padding 16px
    width 60%
    margin-bottom 48px
    .el-select,.el-cascader
      width 100%
</style>